/*
 * Public API Surface of akm-message-lib
 */

export * from './lib/allkeyme-message/index';

